<template>
    <v-layout row wrap v-if="displayHeader"
              :class="[
                  'header',
                  showBrowserMessage ? 'in' : '',
                  'ypo-search-header',
                  isImpersonationMode ? 'header__impersonation' : ''
                  ]">
        <v-flex xs12>
            <v-flex
                :class="['browser-support', showBrowserMessage ? 'class1' : '']"
                v-if="!routeConfigEngagementApp && !isMobileAppBrowser && showBrowserMessage && showMessage"
            >
                {{ appConstant.BROWSER_SUPPORT }}
                <v-btn
                    icon
                    @click="hideBrowserMessage()"
                    class="visible-xs"
                    data-qe-id="header_hide-browser-support_btn"
                >
                    <i class="fas fa-times"></i>
                </v-btn>
            </v-flex>
            <v-layout row wrap justify-center class="header__row">
                <v-flex xs4 sm4 md2 class="header__row__logo display-flex">
                    <div
                        @click="navigateHome"
                        :class="[isSpeakerView ? 'header__row__logo__disabled' : 'pointer']"
                        data-qe-id="header_navigate-home_link"
                    >
                        <icon-ypo-connect-logo width="135" height="30" class="hidden-xs"></icon-ypo-connect-logo>
                        <img src="../../assets/logo-mobile.png" height="25px" class="visible-xs" />
                    </div>
                    <v-btn small class="primary"
                           :class="[
                           isMobileAppBrowser ? 'header__impersonation-mobile-btn' : 'header__impersonation-btn'
                           ]"
                           v-if="isImpersonationMode"
                           @click="endImpersonation">
                      <i class="fas fa-times"></i>
                      {{headerConstant.IMPERSONATION}}
                    </v-btn>
                </v-flex>
                <v-flex class="header__menu--wrapper" v-if="!isSpeakerView">
                  <v-layout class="header__menu">
                    <v-flex>
                      <router-link class="header__menu--option" to="/home" @click.native="hideSearchTray(headerConstant.menu.HOME)">{{headerConstant.menu.HOME}}</router-link>
                    </v-flex>
                    <v-flex>
                      <router-link :class="['header__menu--option', isEventDirectoryPage && 'router-link-active']" to="/eventDirectoryPage"  @click.native="hideSearchTray(headerConstant.menu.EVENTS)">{{headerConstant.menu.EVENTS}}</router-link>
                    </v-flex>
                    <v-flex>
                        <a class="header__menu--option" :href="memberDirectoryUrl" @click.native="hideSearchTray(headerConstant.menu.MEMBERS)">{{headerConstant.menu.MEMBERS}}</a>
                    </v-flex>
                    <v-flex>
                      <router-link class="header__menu--option" to="/resources"  @click.native="hideSearchTray(headerConstant.menu.RESOURCES)">{{headerConstant.menu.RESOURCES}}</router-link>
                    </v-flex>
                    <v-flex class="header__menu--divider ">|</v-flex>
                    <v-flex>
                      <v-menu offset-y attach v-model="moreMenuOpen"
                              nudge-left="30"
                              nudge-bottom="20"
                              transition="slide-y-transition"
                              class="header__menu--option header__menu--more">
                        <v-flex slot="activator"  @click="hideSearchTray(headerConstant.menu.MORE)">
                          {{headerConstant.menu.MORE}}
                          <v-icon :class="['menu-arrow', { 'rotate-arrow': moreMenuOpen }]" size="19">arrow_drop_down</v-icon>
                        </v-flex>
                        <v-list class="header__menu--more--list">
                          <v-list-tile v-for="(item, index) in menuOptions"
                                       :key="index"
                                       @click="handleMenuNavigation(item)" class="header__menu--more--tile">
                            <v-list-tile-title>{{ item.label }}</v-list-tile-title>
                          </v-list-tile>
                        </v-list>
                      </v-menu>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex hidden-xs hidden-sm pr-3 text-xs-right>
                    <v-flex class="header__search" v-if="!isSpeakerView">
                        <v-flex class="relative-position">
                            <global-search-bar
                                ref="globalSearchBar"
                                @clicked-searchInput="emittedFromGlobalSearchBar"
                                :hide-search-tray-from-header="hideSearchTrayFromHeader"
                                :on-focus-callback="true"
                                :show-browser-message="showBrowserMessage"
                                :is-device-ipad="tabSearch"
                            ></global-search-bar>
                        </v-flex>
                    </v-flex>
                </v-flex>
                <v-flex xs8 sm8 md9 lg3 text-xs-right class="header__row__actions" v-if="!isSpeakerView">
                    <v-layout row justify-end>
                        <v-flex class="flex-grow-overwrite header__nav-btn header__nav-btn--visible-md">
                            <v-flex class="hidden-md-and-up-custom">
                                <v-btn flat @click="toggleTabSearch" data-qe-id="header_toggle-search_btn">
                                    <v-icon class="fas fa-search"></v-icon>
                                </v-btn>
                            </v-flex>
                        </v-flex>
                        <v-flex class="flex-grow-overwrite header__nav-btn header__nav-btn--hidden-xs header__non-desktop-menu-item">
                            <v-flex>
                                <v-btn
                                    data-qe-id="header_member-connections_page_btn"
                                    @click="openEventSearchPage()"
                                    flat
                                   >
                                    <v-icon class="fas fa-calendar-alt" title="Event Directory"></v-icon>
                                </v-btn>
                            </v-flex>
                        </v-flex>

                        <v-flex class="flex-grow-overwrite header__nav-btn header__non-desktop-menu-item">

                            <v-flex>
                                <v-btn
                                    data-qe-id="header_member-connections_page_btn"
                                    @click="openMemberConnectionPage()"
                                    flat
                                >
                                    <v-icon class="fas fa-heart" title="My Connections"></v-icon>
                                </v-btn>
                            </v-flex>
                        </v-flex>
                        <v-flex class="flex-grow-overwrite header__nav-btn header__nav-btn--hidden-xs">
                            <v-flex>
                                <v-btn flat @click="openMessengerPage()" data-qe-id="header_messenger-page_btn">
                                    <icon-chat height="24" width="24"></icon-chat>
                                    <v-flex tag="span" class="badge" v-if="showChatNotificationCount">{{
                                        globalChatNotificationCount
                                    }}</v-flex>
                                </v-btn>
                            </v-flex>
                        </v-flex>

                        <v-flex
                            class="flex-grow-overwrite header__nav-btn relative-position"
                            :class="[toggleNotificationTools ? 'active' : '']"
                        >
                            <v-btn flat @click="showNotifications" data-qe-id="header_show-notification_btn">
                                <icon-notification height="20" width="20"></icon-notification>
                                <span class="badge__notification" v-if="notification.notificationCount"></span>
                            </v-btn>

                            <transition name="fade" mode="out-in">
                                <v-flex class="notifications-popup custom-popover" v-show="toggleNotificationTools">
                                    <v-flex class="notifications-popup__details custom-popover__cont">
                                        <h2>{{ notificationsConstants.NOTIFICATIONS }}</h2>
                                    </v-flex>
                                    <v-flex class="notifications-popup__details custom-popover__cont">
                                        <status-overlay
                                            :action="loadingNotificationAction"
                                            content-height="200px"
                                        ></status-overlay>
                                        <v-flex class="inner-scrollbar">
                                            <v-layout
                                                v-for="(notification, i) in notifications"
                                                :key="i"
                                                v-show="notifications"
                                                @click="openLink(notification)"
                                                class="notifications-popup__details__row"
                                            >
                                                <v-flex xs12 class="info-block">
                                                    <figure>
                                                        <img
                                                            :src="notification.fromPersonInfo.profileImageUrl"
                                                            :onerror="
                                                                imageErrorFallback(
                                                                    notification.fromPersonInfo.fallBackProfileImageUrl,
                                                                )
                                                            "
                                                        />
                                                    </figure>
                                                    <div class="notification-message">
                                                        <strong class="notification-message__fromPerson">
                                                            {{ notification.fromPersonInfo.name }}</strong
                                                        >
                                                        {{ notificationFormatter(notification) }}
                                                    </div>
                                                    <small class="sentDate">{{
                                                        getTimeOfPost(notification.sentDateTime)
                                                    }}</small>
                                                </v-flex>
                                            </v-layout>
                                        </v-flex>
                                    </v-flex>
                                    <v-flex
                                        @click="showNotifications"
                                        class="custom-popover__bg"
                                        data-qe-id="header_show-notification_link"
                                    ></v-flex>
                                </v-flex>
                            </transition>
                        </v-flex>
                        <v-flex class="flex-grow-overwrite header__nav-btn header__non-desktop-menu-item">
                            <v-flex>
                                <v-btn
                                    data-qe-id="header_resource-menu-page"
                                    @click="openResourceMenu()"
                                    flat
                                >
                                   <icon-resource-info-ball height="20" class="v-icon header-button-icon"></icon-resource-info-ball>
                                </v-btn>
                            </v-flex>
                        </v-flex>
                        <v-flex class="flex-grow-overwrite header__nav-btn profile">
                            <v-btn
                                @click="hideGlobal('myAccount')"
                                data-qe-id="header_my-account_profile_btn"
                                flat
                                :class="['edit-profile-btn', showHideSideBarCssProfile]"
                                id="editProfile"
                            >
                                <v-avatar>
                                    <img
                                        :src="sizeFormattedImageUrl(profileImageComputed, 150, 150)"
                                        :alt="
                                            profileImage && profileImage.userName ? profileImage.userName : 'My Account'
                                        "
                                        @error="profileImageFailHandler"
                                        title="My Account"
                                    />
                                </v-avatar>
                            </v-btn>
                            <transition name="fade" mode="in-out">
                                <v-flex v-show="myAccountPopup" class="custom-popover">
                                    <v-flex class="custom-popover__cont">
                                        <my-account :hideSideBars="hideSideBars" />
                                    </v-flex>
                                    <v-flex
                                        class="custom-popover__bg"
                                        data-qe-id="header_toggle_my-account_profile_link"
                                        @click="myAccountPopup = !myAccountPopup"
                                    ></v-flex>
                                </v-flex>
                            </transition>
                        </v-flex>
                      <v-flex class="flex-grow-overwrite">
                        <v-flex class="header__nav-btn bars header__non-desktop-menu-item">
                        <v-btn
                            @click="hideGlobalNavBar"
                            data-qe-id="header_bars_btn"
                            flat
                        >
                          <v-icon class="global-mobile-menu__caret" size="24">
                            {{ showGlobalNavMobile ? 'fas fa-times' : 'fas fa-bars' }}
                          </v-icon>
                        </v-btn>
                        </v-flex>
                        <transition name="fade" mode="in-out">
                        <v-flex v-if="showGlobalNavMobile" class="global-mobile-menu">
                            <v-layout column wrap class="global-mobile-menu__details">
                              <v-flex >
                                <v-btn class="global-mobile-menu__details__btn"  @click="openHomePage()">
                                  {{headerConstant.menu.HOME}}
                                </v-btn>
                              </v-flex>
                              <v-flex >
                                <v-btn  class="global-mobile-menu__details__btn" @click="openEventSearchPage()">
                                  {{headerConstant.menu.EVENTS}}
                                </v-btn>
                              </v-flex>
                              <v-flex >
                                <v-btn  class="global-mobile-menu__details__btn" @click="openPeopleSearchPage()">
                                  {{headerConstant.menu.MEMBERS}}
                                </v-btn>
                              </v-flex>
                              <v-flex >
                                <v-btn  class="global-mobile-menu__details__btn" @click="openResourceMenu()">
                                  {{headerConstant.menu.RESOURCES}}
                                </v-btn>
                              </v-flex>
                              <v-flex>
                                <v-menu
                                    offset-y
                                        v-model="moreMenuOpen"
                                        class="global-mobile-menu__details__btn--more"
                                        :value="true"
                                        >
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                        v-bind="attrs"
                                        v-on="on"
                                        class="global-mobile-menu__details__btn"
                                    >
                                      {{ headerConstant.menu.MORE }}
                                      <v-icon
                                          :class="['menu-arrow', { 'rotate-arrow': moreMenuOpen }]"
                                          size="30"
                                          class="global-mobile-menu__details__icon"
                                      >
                                        arrow_drop_down
                                      </v-icon>
                                    </v-btn>
                                  </template>
                                  <v-list class="global-mobile-menu__details__dropdown">
                                    <v-list-item
                                        v-for="(item, index) in menuOptions"
                                        :key="index"
                                        @click="handleMenuNavigation(item)"
                                        class="global-mobile-menu__details__dropdown-item"
                                    >
                                      <v-list-item-title>{{ item.label }}</v-list-item-title>
                                    </v-list-item>
                                  </v-list>
                                </v-menu>
                              </v-flex>
                          </v-layout>
                        </v-flex>
                        </transition>
                      </v-flex>
                    </v-layout>
                </v-flex>
                <v-flex xs8 sm8 md9 lg3 text-xs-right class="header__row__actions" v-if="isSpeakerView">
                    <v-flex class="header__nav-btn profile">
                        <v-btn
                            @click="hideGlobal('myAccount')"
                            data-qe-id="header_my-account_profile_btn"
                            flat
                            :class="['edit-profile-btn', showHideSideBarCssProfile]"
                            id="editProfile_second"
                        >
                            <v-avatar>
                                <img
                                    :src="profileImageComputed"
                                    :alt="profileImage && profileImage.userName ? profileImage.userName : 'My Account'"
                                    @error="profileImageFailHandler"
                                    title="My Account"
                                />
                            </v-avatar>
                        </v-btn>
                        <transition name="fade" mode="in-out">
                            <v-flex v-show="myAccountPopup" class="custom-popover">
                                <v-flex class="custom-popover__cont">
                                    <my-account :hideSideBars="hideSideBars" />
                                </v-flex>
                                <v-flex
                                    class="custom-popover__bg"
                                    data-qe-id="header_toggle_my-account_profile_link"
                                    @click="myAccountPopup = !myAccountPopup"
                                ></v-flex>
                            </v-flex>
                        </transition>
                    </v-flex>
                </v-flex>
            </v-layout>
            <v-layout class="header__search hidden-md-and-up-custom" v-if="tabSearch" row justify-center>
                <v-flex xs10 sm11>
                    <global-search-bar
                        @clicked-searchInput="emittedFromGlobalSearchBar"
                        :hide-search-tray-from-header="hideSearchTrayFromHeader"
                        :on-focus-callback="true"
                        :post-select-callback="toggleTabSearch"
                        :show-browser-message="showBrowserMessage"
                        :is-device-ipad="tabSearch"
                    >
                    </global-search-bar>
                </v-flex>
                <v-flex xs2 sm1 class="cancel-search">
                    <span small flat @click="tabSearch = !tabSearch">{{ globalSearchConstants.CANCEL }}</span>
                </v-flex>
            </v-layout>
        </v-flex>
        <v-layout class="footer-menu" v-if="isFooterVisible">
            <v-flex>
                <v-btn
                    flat
                    :class="isHomeActive ? 'active' : ''"
                    data-qe-id="header_mobile_home-page_btn"
                    @click="openHomePage()"
                >
                    <v-icon size="24">fas fa-home</v-icon>
                </v-btn>
            </v-flex>

            <v-flex>
                <v-btn
                    flat
                    :class="[this.$route.path.includes('/business') ? 'active' : '']"
                    data-qe-id="header_mobile_around-me-page_btn"
                    @click="openAroundMePage()"
                >
                    <v-icon size="24">fas fa-map-marker-alt</v-icon>
                </v-btn>
            </v-flex>
            <v-flex>
                <v-btn
                    data-qe-id="header_mobile_member-connections-page_btn"
                    :class="[this.$route.path.includes('/memberDirectoryPage') ? 'active' : '']"
                    @click="openPeopleSearchPage()"
                    flat
                >
                    <v-icon size="22">fas fa-address-book</v-icon>
                </v-btn>
            </v-flex>
            <v-flex>
                <v-btn
                    flat
                    data-qe-id="header_mobile_event-page_btn"
                    :class="[this.$route.path.includes('/events') ? 'active' : '']"
                    @click="openEventSearchPage()"
                >
                    <v-icon size="22">fas fa-calendar-alt</v-icon>
                </v-btn>
            </v-flex>
            <v-flex>
                <v-btn
                    flat
                    @click="openMessengerPage()"
                    data-qe-id="header_mobile_messenger-page_btn"
                    :class="[this.$route.path.includes('/messenger') ? 'active' : '']"
                    class="relative-position"
                >
                    <v-icon size="22">fas fa-comments</v-icon>
                    <span class="badge footer-menu__notification-badge" v-if="showChatNotificationCount">
                        {{ globalChatNotificationCount }}
                    </span>
                </v-btn>
            </v-flex>
        </v-layout>
        <div v-if="!isMobileAppBrowser">
          <ypo-cookie-policy :accept-cookie-handler="setCookiePolicy"
                             :cookies-policy-link="cookiePolicyUrl"
                             :cookies-policy-accepted="cookiesPolicyAccepted"></ypo-cookie-policy>
        </div>
        <div v-if="$vuetify.breakpoint.xs && displayCommunityMenuBar" class="relative-position">
            <menu-bar></menu-bar>
        </div>
        <div><ypo-concierge-floater></ypo-concierge-floater></div>
    </v-layout>
</template>

<script>
import { storeAction } from '@/store/storeActions.constant';
import { storeGetters } from '@/store/storeGetters.constant';
import { headerConstant, notificationsConstants, menuOptions } from '../Header/header.constant.js';
import { loginConstants } from '../LoginPage/login.constants.js';
import myAccount from '../../components/MyAccount/MyAccount';
import myTools from '../../components/Tools/MyTools';
import { mapMutations, mapGetters, mapActions, mapState } from 'vuex';
import { storeMutation } from '@/store/storeMutations.constant';
import { appConstant } from '@/app.constant';
import { getMonthDateTimeForNotifications, getTimeOfPost } from '@/common/utils/dateTime';
import { onMessage, getMessaging } from 'firebase/messaging';
import { routerNames, routesContainingMobileMenu } from '@/components/appCommon.constants';
import IconYpoConnectLogo from '../../components/Icons/IconYpoConnectLogo';
import IconGrid from '../../components/Icons/IconGrid';
import IconResourceInfoBall from '../Icons/IconResourceInfoBall';
import { imageErrorFallback } from '@/common/utils/utils';
import IconYpoLogo from '../Icons/IconYpoLogo';
import { speakerRegistrationConstants } from '../Speakers/speakerConstant';
import GlobalSearchBar from '../YpoSearch/GlobalSearchBar';
import { globalSearchConstants } from '../YpoSearch/ypoSearch.constants';
import MenuBar from '@/components/Layout/Menu';
import notificationsMethods from '../../mixins/notificationsMixin';
import StatusOverlay from '../StatusOverlay/StatusOverlay';
import YpoCookiePolicy from "@/components/YpoCookiePolicy/YpoCookiePolicy";
import IconChat from "@/components/Icons/IconChat.vue";
import IconNotification from "@/components/Icons/IconNotification.vue";
import YpoConciergeFloater from "@/components/YpoConcierge/YpoConciergeFloater.vue";
import YpoConciergeLayout from "@/components/YpoConcierge/YpoConciergeLayout.vue";
import ClickOutside from "vue-click-outside";
import YpoConciergeWrapper from "@/components/YpoConcierge/YpoConciergeWrapper.vue";
import { commonEnvVariables } from "@/commonEnvVariables";
import { sizeFormattedImageUrl } from "@/common/utils/cloudinaryUtils";

export default {
    name: 'Header',
    data: () => ({
        showMessage: true,
        headerConstant,
        speakerRegistrationConstants,
        loginConstants,
        toggle: false,
        toggleTools: false,
        toggleNotificationTools: false,
        trackToggle: false,
        tabSearch: false,
        toolsToggle: false,
        myAccountPopup: false,
        showGlobalNavMobile: false,
        appConstant,
        notification: {
            notificationCount: 0,
        },
        notifications: null,
        notificationsConstants,
        isAcceptPrivacyChecked: false,
        profileImageFailureFlags: {},
        globalSearchConstants,
        loadingNotificationAction: {
            pending: false,
        },
        hideSearchTrayFromHeader: false,
        displayConciergeHelpMenu: false,
        menuOptions: null,
        moreMenuOpen: false,
        sizeFormattedImageUrl,
    }),
    mixins: [notificationsMethods],
    directives: {
     ClickOutside,
    },
    components: {
        YpoConciergeWrapper,
        YpoConciergeLayout,
        YpoConciergeFloater,
        YpoCookiePolicy,
        MenuBar,
        GlobalSearchBar,
        myAccount,
        myTools,
        IconYpoConnectLogo,
        IconGrid,
        IconResourceInfoBall,
        IconYpoLogo,
        IconChat,
        IconNotification,
        StatusOverlay,
    },
    created() {
        this.getSystemMessages();
        if (!this.isSpeakerView && this.speakerRegistrationStatus === null) {
            this.getSpeakerRegistrationStatus(this.personId);
        }
        if (
            localStorage.getItem(appConstant.DEFAULT_IS_FIREBASE_SUPPORTED) ===
            appConstant.DEFAULT_FIREBASE_SUPPORTED_TRUE
        ) {
            this.initFCM(this.notification);
        }
        this.getPRPRole();
        this.unReadNotificationCount();
        this.getPasswordPolicies();
        this.menuOptions = menuOptions();
    },
    watch: {
       currentUserId(id) {
            if (id) {
                this.unReadNotificationCount();
            }
        },
    },
    methods: {
        ...mapMutations({
            toggleMainPageOverflow: `${[storeMutation.toggleMainPageOverflow]}`,
            setMemberDirectorySearchText: `memberDirectory/${storeMutation.setMemberDirectorySearchText}`,
            setPRPRole: `chapterWaiver/${storeMutation.setPRPRole}`,
            setMemberSelectedLetterFilter: `memberDirectory/${storeMutation.setMemberSelectedLetterFilter}`,
            updateMemberSelectedLetterFilter: `memberDirectory/${storeMutation.updateMemberSelectedLetterFilter}`,
            setCookiePolicy: `auth/${storeMutation.setCookiePolicy}`,
        }),
        handleMenuNavigation(item) {
          this.clearSearchTrayText = true;
          this.hideSearchTrayFromHeader = true;
          this.moreMenuOpen = false;
          let url = item.url;
          const appOrigin = window.location.origin;
          if (url && !url.includes('http')) {
            url = `https://${url}`;
          }
          if (url.includes(appOrigin) || (this.isMobileAppBrowser)) {
            window.open(url, "_self");
          } else {
            window.open(url, "_blank");
          }
        },
        hideSearchTray(redirectType) {
          this.hideSearchTrayFromHeader = false;
          if (redirectType.toLowerCase() === 'events') {
            setTimeout(() => {
              this.$refs.globalSearchBar.clearSearchText(true);
              this.hideSearchTrayFromHeader = true;
            }, 2000);
          } else {
            this.$refs.globalSearchBar.clearSearchText(true);
            this.hideSearchTrayFromHeader = true;
          }
        },
        navigateHome() {
            if (!this.isMobileAppBrowser || this.routeConfigEngagementApp) {
                setTimeout(() => {
                    this.hideSearchTrayFromHeader = true;
                    this.$refs.globalSearchBar.clearSearchText(true);
                }, 400);
                this.$router.push('/home');
            }
        },
        endImpersonation() {
          sessionStorage.removeItem(appConstant.storageKeys.impersonationKey);
          this.$router.go();
        },
        hideBrowserMessage() {
            this.showMessage = false;
        },
        toggleTabSearch() {
            this.tabSearch = !this.tabSearch;
            this.showGlobalNavMobile = false;
        },
        showHideTools() {
            this.toolsToggle = false;
            this.showGlobalNavMobile = false;
        },
        forwardToExternalLink(displayName) {
            if (this.termsPrivacyURLs) {
                const linkObjects = this.termsPrivacyURLs.find(item => item.name.toLowerCase() === displayName.replace('.', '').toLowerCase());
                window.open(linkObjects.navigationUrl, '_blank');
            }
        },
        ...mapActions({
            getUnReadNotificationCount: `notification/${storeAction.getUnReadNotificationCount}`,
            getnotifications: `notification/${storeAction.getnotifications}`,
            updateNotificationsToIsRead: `notification/${storeAction.updateNotificationsToIsRead}`,
            saveTermsAndConditions: `auth/${storeAction.saveTermsAndConditions}`,
            getSpeakerRegistrationStatus: `speaker/${storeAction.getSpeakerRegistrationStatus}`,
            getPRPRole: `chapterWaiver/${storeAction.getPRPRole}`,
            getSystemMessages: `notification/${storeAction.getSystemMessages}`,
            getPasswordPolicies: `manageLoginSecurity/${storeAction.getPasswordPolicies}`,
        }),
        getMonthDateTimeForNotifications,
        imageErrorFallback,
        emittedFromGlobalSearchBar(value) {
            this.hideSearchTrayFromHeader = value;
        },
        hideGlobalNavBar () {
        this.showGlobalNavMobile = !this.showGlobalNavMobile;
        },
        hideGlobal(menuType) {
            this.hideSearchTrayFromHeader = true;
            this.$refs.globalSearchBar.clearSearchText(true);
            if (menuType === 'myAccount') {
                this.myAccountPopup = !this.myAccountPopup;
                this.showGlobalNavMobile = false;
            }
            if (menuType === 'tools') {
                this.toolsToggle = !this.toolsToggle;
            }
        },
        initFCM(notification) {
          const messaging = getMessaging();
          onMessage(messaging, (payload) => {
            if (payload && payload.data) {
              notification.notificationCount = payload.data.unviewedcount;
            }
          });
        },
        unReadNotificationCount() {
            if (!this.isSpeakerView) {
                this.getUnReadNotificationCount(this.currentUserId).then((res) => {
                    this.notification.notificationCount = res.data;
                });
            }
        },
        notificationBind() {
            this.loadingNotificationAction.pending = true;
            this.getnotifications(this.currentUserId).then((res) => {
                this.notifications = res.data;
                this.notificationsToIsRead();
            });
        },
        notificationsToIsRead() {
            this.updateNotificationsToIsRead(this.currentUserId).then(() => {
                this.notification.notificationCount = 0;
            });
            this.loadingNotificationAction.pending = false;
        },
        openMessengerPage() {
            setTimeout(() => {
                this.hideSearchTrayFromHeader = true;
                this.showGlobalNavMobile = false;
                this.$refs.globalSearchBar.clearSearchText(true);
            }, 400);
            this.$router.push({
                name: routerNames.MESSENGER,
            });
        },
        openResourceMenu() {
            this.$router.push({
                name: routerNames.RESOURCE_MENU_PAGE,
            });
          this.showGlobalNavMobile = false;
        },
        openMemberConnectionPage() {
            setTimeout(() => {
                this.hideSearchTrayFromHeader = true;
                this.showGlobalNavMobile = false;
                this.$refs.globalSearchBar.clearSearchText(true);
            }, 400);
            this.setMemberDirectorySearchText('');
            if (this.$route.name !== routerNames.MEMBER_CONNECTIONS) {
                const filterFromStorage = sessionStorage.getItem(appConstant.storageKeys.connectionDirectoryStoredFilters);
                this.updateMemberSelectedLetterFilter(filterFromStorage);
                this.$router.push({
                    path: '/memberConnections',
                    filters: sessionStorage.getItem(appConstant.storageKeys.connectionDirectoryStoredFilters) || null,
                });
            }
        },
        openPeopleSearchPage() {
            window.open(commonEnvVariables().FULL_MEMBER_DIRECTORY, '_self');
            this.showGlobalNavMobile = false;
        },
        openHomePage() {
            this.$router.push({
                path: '/home',
            });
          this.showGlobalNavMobile = false;
        },
        openAroundMePage() {
            this.$router.push({
                path: '/businesses',
            });
        },
        openEventSearchPage() {
            this.$router.push({
                path: '/eventDirectory',
            });
          this.showGlobalNavMobile = false;
        },
        hideSideBars() {
            this.myAccountPopup = false;
            this.showGlobalNavMobile = false;
        },
        showNotifications() {
            this.hideSearchTrayFromHeader = true;
            this.showGlobalNavMobile = false;
            this.$refs.globalSearchBar.clearSearchText(true);
            this.toggleNotificationTools = !this.toggleNotificationTools;
            if (this.toggleNotificationTools) {
                this.notificationBind();
            }
        },
        profileImageFailHandler() {
            const desiredImage = this.profileImageUrlWithTimestamp;
            this.profileImageFailureFlags = {
                ...this.profileImageFailureFlags,
                [desiredImage]: true,
            };
        },
        getTimeOfPost,
        toggleConciergeMenu() {
          this.hideSearchTray('concierge');
          this.displayConciergeHelpMenu = !this.displayConciergeHelpMenu;
        },
    },
    computed: {
        ...mapState('actionState', ['actions']),
        ...mapGetters({
            profileInformation: `myAccount/${storeGetters.profileInformation}`,
            speakerRegistrationStatus: `speaker/${storeGetters.speakerRegistrationStatus}`,
            currentUserId: `memberProfile/${storeGetters.currentUserId}`,
            isImpersonationMode: `auth/${storeGetters.isImpersonationMode}`,
            profileImage: `myAccount/${storeGetters.profileImage}`,
            cookiesPolicyAccepted: `auth/${storeGetters.cookiesPolicyAccepted}`,
            cookiePolicyUrl: `openAPI/${storeGetters.cookiePolicyUrl}`,
            globalChatNotificationCount: `messenger/${storeGetters.globalChatNotificationCount}`,
            isMobileAppBrowser: `${[storeGetters.isMobileAppBrowser]}`,
            isSpeakerView: `auth/${storeGetters.isSpeakerView}`,
            personId: `auth/${storeGetters.currentUserId}`,
            systemMessages: `notification/${storeGetters.systemMessages}`,
            termsPrivacyURLs: `openAPI/${storeGetters.termsPrivacyURLs}`,
            conciergeFeatureFlag: `ypoConciergeService/${storeGetters.conciergeFeatureFlag}`,
            routeConfigHideFooter: `${[storeGetters.routeConfigHideFooter]}`,
            routeConfigHideHeader: `${[storeGetters.routeConfigHideHeader]}`,
            routeConfigEngagementApp: `${[storeGetters.routeConfigEngagementApp]}`,
        }),
        isEventDirectoryPage() {
          return this.$route && this.$route.name === routerNames.YPO_EVENTS;
        },
        isFooterVisible() {
          return !this.routeConfigHideFooter && !this.isMobileAppBrowser && this.$vuetify.breakpoint.xs;
        },
        showHideSideBarCssProfile() {
            return this.toggle ? 'active' : '';
        },
        memberDirectoryUrl(){
            return commonEnvVariables().FULL_MEMBER_DIRECTORY;
        },
        browserInfo() {
            const ua = navigator.userAgent;
            let tem = '';
            let M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
            if (/trident/i.test(M[1])) {
                tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
                return { name: 'IE', version: tem[1] || '' };
            }
            if (M[1] === 'Chrome') {
                tem = ua.match(/\bOPR|Edge|EdgA\/(\d+)/);
                if (tem && tem[0] && tem[0] === 'OPR') {
                    return { name: 'Opera', version: tem[1] };
                } else if (
                    tem &&
                    tem[0] &&
                    (tem[0].toLowerCase().includes('edge') || tem[0].toLowerCase().includes('edga'))
                ) {
                    return { name: 'Edge', version: tem[1] };
                }
            }
            M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
            // eslint-disable-next-line no-cond-assign
            if ((tem = ua.match(/version\/(\d+)/i)) != null) {
                M.splice(1, 1, tem[1]);
            }
            return {
                name: M[0],
                version: M[1],
            };
        },
        showBrowserMessage() {
            const isIpad = /iPad/i.test(navigator.userAgent);
            const isIphone = /iPhone/i.test(navigator.userAgent);
            return (
                (this.browserInfo &&
                    this.browserInfo.name &&
                    this.browserInfo.name.toLowerCase() !== 'chrome' &&
                    this.browserInfo.name.toLowerCase() !== 'safari' &&
                    !isIphone) ||
                isIpad
            );
        },
        profileImageUrlWithTimestamp() {
            return this.profileImage && this.profileImage.originalImage
                ? `${this.profileImage.originalImage}`
                : null;
        },
        profileImageComputed() {
            const desiredImage = this.profileImageUrlWithTimestamp;
            if (this.profileImageFailureFlags[desiredImage]) {
                return this.profileImage.fallBackImage;
            }
            return desiredImage;
        },
        showChatNotificationCount() {
            return this.globalChatNotificationCount;
        },
        displayCommunityMenuBar() {
            return routesContainingMobileMenu.includes(this.$route.name.toLowerCase());
        },
        displayHeader() {
            let result = true;
            if (
                this.$route.name &&
                this.$route.name.toLowerCase() === routerNames.BUSINESSES.toLowerCase() &&
                this.isMobileAppBrowser
            ) {
                result = false;
            }
            if (this.routeConfigHideHeader) result = false;
            return result;
        },
        isHomeActive() {
            return routesContainingMobileMenu.some(item => this.$route.name && item.toLowerCase() === this.$route.name.toLowerCase());
        },
    },
};
</script>

<style lang="scss">
@import '../../common/styles/_colors.scss';
@import '../../common/styles/_commonClasses.scss';
@import '../../common/styles/_responsive.scss';

.header {
    min-height: 64px;
    background: $ypo_blue;
    padding-left: 10px;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 100;
    width: 100%;

    &__impersonation {
      background-color: $ypo-red !important;

      &-btn {
        text-transform: capitalize !important;
        font-size: 16px;
        position:absolute;
        left: 0;
        bottom: -34px;
        border-radius: 0 0 4px 0;

        i {
          padding-right: 5px;
        }

        @include breakpointMin(sm) {
          font-size: 16px;
          bottom: -28px;
          margin: 0;
        }
        &:hover {
          position:absolute;
        }
      }

      &-mobile-btn {
        font-size: 11px;
        margin: 3px 0 0 4px;
        bottom: 15px;
        left: 56px;
        text-transform: capitalize !important;
        position:absolute;
        i {
          padding-right: 5px;
        }
        &:hover {
          position:absolute;
        }
      }

      .v-btn {
        .v-icon {
          opacity: .8 !important;
        }
      }
    }

    @media only screen and (min-width: 1024px) {
        .hidden-md-and-up-custom {
            display: none !important;
        }
    }

    &__row {
        align-items: center;

      &__logo {
        @include breakpointMin(md) {
          max-width: 180px !important;
        }
      }

        &__logo__disabled {
            pointer-events: none;
        }
    }

    .header__nav-btn {
        display: inline-block;
        position: relative;
        cursor: pointer;

        .assist_nav {
            font-size: 30px;
            color: $ypo-dark-background-gray;
            cursor: pointer;
        }

        &.profile {
            padding: 0;
        }
        &.bars {
          color: white;
          font-size: 20px;
          cursor: pointer;
          padding:0 14px;
        }
        &.warning-icon {
            transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
            &:hover {
                background: rgba($black, 0.15);
            }
            .warning-btn {
            height: 100%;
            padding: 0 14px;
            a {
                position: relative;
                width: 100%;
                height: 100%;
                display: inline-block;
                padding: 0 10px;
                &:before {
                    content: "";
                    background: url("../../assets/connect-triangle.png");
                    position: absolute;
                    width: 20px;
                    height: 100%;
                    left: 0;
                    top: 0;
                    opacity: 1;
                    background-size: contain;
                    background-position: center center;
                    background-repeat: no-repeat;
                }
            }
            }
        }

        .v-btn {
            padding: 0 14px;
            margin: 0;
            min-width: inherit;
            display: inline-block;
            height: 64px;

            .v-icon {
                color: $white;
                opacity: 0.7;
                font-size: 20px;

            }
        }

        &.active {
            .v-btn {
                background: rgba($black, 0.2);

                .v-icon {
                    opacity: 1;
                    font-weight: 600;
                }
            }
        }

        &--visible-md {
            display: none;

            @include breakpoint(md) {
                display: block;
            }
        }

        &--hidden-xs {
            @include breakpoint(xs) {
                display: none;
            }
        }
    }

    .header-button-icon {
      fill: $ypo-light-gray;
    }

    .search_bar {
        label {
            color: $white !important;
        }

        i {
            color: $white !important;
        }
    }

    &__search {
        margin-top: 7px;
        margin-bottom: 7px;
        color: $white;

        &__field {
            border-right: 1px solid rgba($ypo-medium-gray, 0.3);

            &:first-child {
                border-left: 1px solid rgba($ypo-medium-gray, 0.3);
            }

            &.last {
                .v-menu > .v-menu__content {
                    left: auto !important;
                    right: 50px;
                }
            }
        }

        .v-text-field__details {
            display: none;
        }

        .v-input {
            &__slot {
                margin: 0;
                padding: 0;
                border: 1px solid transparent !important;
                min-height: inherit !important;
            }

            .v-label {
                color: rgba($white, 0.6);
                font-size: 14px;
                top: 10px;
            }

            .v-icon {
                color: rgba($white, 0.6);
            }

            input {
                color: $white !important;
                margin-top: 5px;
            }

            .v-input__append-inner {
                margin-top: 8px;
            }

            &--is-focused {
                background: $ypo_cta-secondary;
            }
        }
    }

    &__logo {
        &-main {
            display: block;

            @include breakpoint(sm) {
                display: none;
            }
        }

        &-mobile {
            display: none;

            @include breakpoint(sm) {
                display: block;
                max-width: 35px;
            }
        }
    }

    .preview-label {
        position: absolute;
        left: 160px;
        top: 23px;
        color: $ypo-gold;

        &__label {
            text-transform: uppercase;
            margin-right: 5px;
            font-size: 14px;
            opacity: 0.9;
        }

        i {
            font-size: 12px;
        }
    }

    .badge {
        background: $ypo-gold;
        border-radius: 50%;
        font-size: 12px;
        width: 20px;
        height: 20px;
        font-weight: 600;
        line-height: 20px;
        position: absolute;
        top: -10px;
        right: -10px;

      &__notification {
        width: 11px;
        height: 11px;
        position: absolute;
        top: -2px;
        right: 0;
        background-color: limegreen;
        border: 2px solid $white;
        border-radius: 50%;
      }
    }

  &__menu {

    .router-link-active {
      color: $white;
      background-color: $ypo-blue-tertiary;
      padding-top: 6px;
      border-bottom: 6px solid $ypo-gold;
      text-decoration: none;
    }

    &--wrapper {
      display: none;
      max-width: 680px;

      @include breakpointMin(lg) {
        display: block;
      }
    }

    &--divider {
      color: $white;
      height: 64px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      text-align: center;
    }

    &--option {
      color: $white;
      height: 64px;
      padding: 0 5px;
      display: flex;
      font-size: 13px;
      font-weight: 600;
      flex-direction: column;
      justify-content: center;
      text-align: center;
      text-decoration: none;
      cursor: pointer;

      &:hover {
        background-color: $ypo-blue-tertiary;
      }
    }

    &--more {
      flex-direction: row;
      align-items: center;
      box-shadow: none !important;
      .v-icon {
        color: $white;
        caret-color: $white;
      }

      .v-list {
        position: relative;
        padding: 0;
        background-color: $white;
        max-height: 300px;
        overflow: auto;
        width: 200px;
        border-left: 1px solid rgba($ypo-gray, 0.5);
        border-right: 1px solid rgba($ypo-gray, 0.5);
        border-bottom: 1px solid rgba($ypo-gray, 0.5);

        .v-list__tile {
          padding-top: 15px;
          padding-bottom: 15px;
          height: 45px;
          background-color: $white;
          color: $ypo-blue;

          &:hover {
            color: $white;
            background-color: $ypo-blue;
          }
        }

        a {
          text-decoration: none;
          font-size: 12px;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
        }
      }
    }

    .menu-arrow {
      transition: transform 0.3s ease;
    }

    .rotate-arrow {
      transform: rotate(180deg);
    }

    .concierge-menu-option {
      &--selected {
        background-color: $ypo-blue-tertiary;
      }

      &__menu {
        position: absolute;
        top: 41px;
        left: -4px;
        z-index: 10000;

        .ypo-concierge-layout {
          border-radius: 0;
          border: none;
          box-shadow: none;

          &__title {
            border-radius: 0;
            background-color: $ypo-blue-tertiary;
            text-align: left;
          }

          .concierge-option {
            border: 1px solid $ypo-medium-gray !important;
            border-top: none !important;
          }
        }
      }
    }
  }

  &__non-desktop-menu-item {
    @include breakpointMin(lg) {
      display: none !important;
    }
  }
}

.global-mobile-menu {
  right: 0;
  z-index: 100;
  top: 50px;
  position: fixed;
  background: $ypo-blue !important;
  color: white;
  overflow-y: auto;
  min-width: 350px;
  min-height: 500px;

  @include breakpoint(xs) {
    width: 100vw;
    height: calc(100vh - 110px) ;
  }

  @include breakpoint(sm) {
    min-width: 350px;
    height: calc(100vh - 110px) ;
  }
  @include breakpoint(md) {
    min-width: 350px;
    height: 700px;
  }

  &__caret {

  }

  &__details {
    justify-content: center;
    align-content: center;
    margin: 20px 0;
    flex-direction: column;

    @include breakpoint(xs) {
      margin: 10px 0;
    }

    &__btn {
      width: 300px;
      margin: 15px 0;
      border-radius: 15px;
      text-align: left !important;
      padding:25px;
      justify-content: flex-start !important;
      align-items: center;
      display: flex;
      background: $ypo-header-global-nav-grey !important;
      font-size: 14px;
      font-weight: 500;


      @include breakpoint(xs) {
        margin: 10px 0;
        padding:22px;
      }
      @include breakpoint(sm) {
        margin: 10px 0;
        padding:22px;
      }
    }
    &__btn--more {
      width: 100%;
    }
    &__icon {
      margin-left: auto;
    }

    &__dropdown {
      width: 300px;
      margin-top: 24px;
      border-radius: 10px;
      padding: 0;
      color: white;
      background: $ypo-header-global-nav-more-grey !important;
    }

    &__dropdown-item {
      border-bottom: 1px solid gray;
      padding: 15px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-weight: 500;
      font-size: 14px;
      &:last-child {
        border-bottom: 0;
      }

      @include breakpoint(xs) {
        padding: 10px 16px;
      }
    }
  }
  .menu-arrow {
    transition: transform 0.3s;
  }

  .rotate-arrow {
    transform: rotate(180deg);
  }
}

.global-mobile-menu__details__btn .v-btn__content {
  @include breakpoint(xs) {
    width: 100%;
    justify-content: flex-start !important;
    text-align: left !important;
    padding-left: 0 !important;
  }
  @include breakpoint(sm) {
    width: 100%;
    justify-content: flex-start !important;
    text-align: left !important;
    padding-left: 0 !important;
  }
  @include breakpoint(md) {
    width: 100%;
    justify-content: flex-start !important;
    text-align: left !important;
    padding-left: 0 !important;
  }
}

.edit-profile {
    &__details {
        padding: 20px;
        border-bottom: 1px solid $ypo-medium-gray;
        min-height: 150px;


        &__btn {
            height: auto !important;
            background-color: $ypo-gold !important;
            font-size: 14px !important;
            color: $white !important;
            padding: 5px 20px !important;
            box-shadow: none !important;
            border-radius: 4px !important;
            font-weight: 600;
            cursor: pointer;
        }
    }

    &__status {
        font-size: 14px;
        text-transform: none;
        display: block;
        text-align: left;
        color: $ypo-cta;
        margin-bottom: 10px;
    }

    &__name {
        text-transform: none;
        display: block;
        font-size: 18px;
        font-weight: 600;
        color: $ypo_blue;
        text-align: left;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
    }

    &__btn {
        font-size: 14px;
        text-transform: none;
        background: $ypo-gold !important;
        border: 1px solid $white;
        padding: 4px 25px;
        color: $ypo-blue !important;
        border-radius: 4px;
        font-weight: 600;
        height: auto;
    }

    &__container {
        position: relative;
        z-index: 10;
        background: $white;
        height: 100%;

        .inner-scrollbar {
            margin-right: 0;
        }

        .v-card {
            box-shadow: none;
            background: transparent;
        }
    }
}

.right-fixed-panel {
    position: fixed;
    right: 0;
    z-index: 9;
    width: 350px;
    top: 64px;
    background: $white;
    max-height: 95vh;
    overflow: auto;
}

.overlay-bg {
    position: relative;
    transition: all 0.001s ease;

    &:before {
        content: '';
        position: fixed;
        right: 5px;
        width: 100%;
        height: 100%;
        background: rgba($black, 0.1);
        top: 64px;
    }
}

.edit-profile-btn {
    &.active {
        position: relative;
        border-radius: 0;

        &:before {
            content: '';
            background: $black;
            position: absolute;
            width: 100%;
            height: 100%;
            left: 0;
            z-index: 1;
            opacity: 1;
        }

        &:after {
            content: '\f106';
            position: absolute;
            left: 0;
            right: 0;
            font-family: 'Font Awesome 5 Free';
            font-size: 30px;
            z-index: 1;
            font-weight: 900;
        }
    }

    &__caret {
      padding-left: 20px;
    }
}

.tools-btn {
    &.active {
        position: relative;
        border-radius: 0;

        &:before {
            background: $black;
            position: absolute;
            width: 100%;
            height: 100%;
            opacity: 1;
        }

        &:after {
            position: absolute;
            color: $white;
        }
    }
}

.notifications-popup {
    h2 {
        border-bottom: 1px solid $black;
    }

    &__details {
        position: relative;
        text-align: left;

        .inner-scrollbar {
            min-height: 50px;
            max-height: 430px;
            overflow-y: auto;
            &::-webkit-scrollbar {
                width: 5px;
                background-color: $white;

                /* or add it to the track */
            }

            /* Add a thumb */
            &::-webkit-scrollbar-thumb {
                background: $ypo-cta;
                border-radius: 0;
            }
        }

        &__row {
            margin-right: 1px;
            position: relative;
            align-items: center;
            margin-bottom: 0;
            border-bottom: 1px solid $ypo-light-medium-gray;
            padding: 7px 10px 10px 10px;
            transition: 0.3s all ease;
            cursor: pointer;

            .info-block {
                position: relative;
                min-height: 50px;
                align-items: center;
                padding-right: 17px;

                figure {
                    position: absolute;
                    width: 45px;
                    border: 3px solid $ypo-light-medium-gray;
                    border-radius: 50%;
                    height: 45px;
                    overflow: hidden;
                    top: 7px;
                    left: 0;

                    img {
                        max-width: 100%;
                    }
                }

                small {
                    padding-left: 50px;
                    font-size: 12px;
                    display: block;
                    line-height: normal;
                    color: rgba($ypo-blue, 0.6);
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    overflow: hidden;
                }

                .sentDate {
                    margin-top: 4px;
                    font-size: 11px;
                    color: $ypo-gray;
                    font-family: inherit;
                }
            }

            .notification-message {
                font-size: 14px;
                padding-left: 50px;
                display: block;
                line-height: 1.2;
                margin-top: 5px;
                color: $black;
                text-overflow: ellipsis;
                white-space: nowrap;
                overflow: hidden;
                @supports (-webkit-line-clamp: 2) {
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: initial;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                }

                &__fromPerson {
                    color: $ypo-cta;
                }
            }

            &:hover {
                background: $ypo-cta;

                .notification-message,
                .sentDate,
                .notification-message__fromPerson {
                    color: $white;
                }
            }

            span {
                color: $ypo-gray-text;
                font-size: 12px;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                display: block;
                width: 100%;
            }
        }
    }

    &__overlay {
        position: relative;
        z-index: 1;

        &:after {
            content: '';
            width: 100%;
            height: 100vh;
            background: rgba($black, 0.05);
            position: fixed;
            left: 0;
            top: 60px;
            z-index: 1;
            cursor: default;
        }
    }
}

.privacy_popup {
    .logo {
        align-items: center;
    }

    .policy-text {
        position: relative;
        padding-left: 36px;
    }

    .v-input--selection-controls {
        position: absolute;
        left: 4px;
    }

    @include breakpoint(xs) {
        &.v-card {
            h6 {
                font-size: 18px !important;
                margin-left: 14px !important;
                white-space: nowrap;
            }
        }
    }
}

@-moz-document url-prefix() {
    .overlay-bg {
        &:before {
            right: 15px;
        }
    }
}

.tabview-search {
    display: none;

    @media (max-width: 1199px) {
        display: flex;
        position: fixed;
        top: 25px;
        z-index: 10;
        left: 0;
        width: 100%;
        background: $ypo_blue;
        min-height: 56px;
        padding: 10px 55px 10px 15px;
        margin: 0;

        @include breakpoint(sm) {
            top: 40px;
        }
    }

    .close-search {
        position: absolute;
        color: $white;
        font-size: 22px;
        opacity: 0.4;
        top: 18px;
        right: 18px;
    }

    .search-result-item {
        color: $white;
    }
}

@media (max-width: 767px) {
    .notifications-popup {
        top: 99px;
        min-width: auto;
        position: fixed;
        z-index: 101;
    }

    .header {
        .header__nav-btn {
            .edit-profile {
                &__container {
                    .v-avatar {
                        width: 60px !important;
                        height: 60px !important;
                    }
                }


                &__back {
                    text-align: left;
                }


                &__details__btn {
                    &.v-btn {
                        height: 35px !important;
                        margin-right: 74px;
                    }
                }

                &__details {
                    min-height: 120px;
                }
            }

            @include breakpoint(xs) {
                .v-btn__content {
                    .v-icon {
                        font-size: 18px !important;
                    }
                }
            }
        }
    }

    .tabview-search {
        position: absolute;
        top: 54px;
        min-width: 100%;
        display: block;
        margin: 0;
        padding: 0;
        background: $ypo-extra-light-gray;
        box-shadow: 0 3px 1px -2px rgba($black, 0.2), 0px 2px 2px 0px rgba($black, 0.14),
            0px 1px 5px 0px rgba($black, 0.12);
        z-index: 101;

        &__cont {
            position: relative;
            z-index: 13;
            background: $white;
            padding: 10px;
            display: inherit;
        }

        &__close {
            position: relative;
            z-index: 12;

            &:before {
                content: '';
                position: fixed;
                width: 100%;
                height: 100%;
                background: rgba($white, 0.09);
                top: 0;
                left: 0;
                z-index: 102;
            }
        }

        .header__search__field {
            border: 1px solid $ypo-blue;
            margin-top: 15px;

            &:first-child {
                margin-top: 0;
            }

            .v-menu {
                display: block;
            }

            .v-input,
            .v-label,
            .v-icon {
                color: $ypo-blue !important;
                caret-color: $ypo-blue !important;
            }

            .mail-icon {
                color: $white !important;
            }

            .v-input {
                &--is-focused {
                    background: transparent;
                    color: $ypo-blue !important;
                }

                input {
                    color: $ypo-blue !important;
                }
            }

            &.last {
                .v-menu > .v-menu__content {
                    left: auto !important;
                    right: auto;
                }
            }

            .v-menu__content {
                box-shadow: none;
            }
        }

        .close-search {
            color: $ypo-blue;
            right: 11px;
            opacity: 0;
            top: auto;
            bottom: 5px;
            visibility: hidden;
        }
    }
}

.browser-support {
    background: $ypo-medium-gray;
    font-size: 12px;
    padding: 2px 10px;
    margin: 0 -10px;
    flex: auto;
    width: auto;
    max-width: initial;

    @include breakpoint(xs) {
        position: fixed;
        top: 0;
        z-index: 1;
        padding: 10px 40px 10px 10px;

        .v-btn {
            padding: 0;
            margin: 0;
            position: absolute;
            right: 10px;
            bottom: 0;
        }
    }
}

.header.in + .flex .banner-view {
    margin-top: 85px;

    @include breakpoint(sm) {
        margin-top: 104px;
    }
}

.cookies-policy {
    background: $ypo-cta-secondary;
    position: fixed;
    bottom: 0;
    padding: 15px 10px 15px 70px;
    color: rgba($white, 0.7);
    font-size: 12px;
    line-height: normal;
    left: 0;
    width: 100%;

    a {
        font-weight: 600;
        color: $white;
    }

    @media (max-width: 767px) {
        padding: 10px;
        z-index: 101;
        display: block;
        text-align: center;
        font-size: 12px;
        line-height: normal;
    }
}

@supports (-ms-ime-align: auto) {
    .browser-support {
        padding: 10px;
        font-size: 14px;
    }

    .assistPage,
    .content-directory-page,
    .member-directory-page,
    .event-directory-page,
    .community-directory-page {
        margin-top: 100px !important;
    }
}

.header--hidden {
    display: none;
    & + .nonbrowser-view {
        .mobile-menu {
            top: 0;
        }
        .banner-view {
            margin-top: 50px !important;
        }
        .businesses_banner {
            display: none;
            & + .layout {
                display: none;
                & + .layout {
                    .mobile-menu {
                        display: none;
                    }
                }
            }
        }
        .businesses {
            .v-carousel {
                display: none;
            }
        }
    }
    & + .privacy-settings {
        h2 {
            margin-top: 0 !important;
        }
    }
    & + .polices_procedures {
        padding-top: 10px !important;
    }
    & + .member-profile {
        margin-top: 0 !important;
    }
}

.ypo-search-header {
    .cancel-search {
        z-index: 2;
        color: $white;
        padding: 9px 0 9px 9px;
        font-family: Raleway, sans-serif;
        font-size: 12px;
        font-weight: 500;
        line-height: 14px;
        margin-right: -10px !important;
        @include breakpoint(xs) {
            margin-right: 1px !important;
        }
    }

    .tabview-search {
        display: none;

        @media (max-width: 1199px) {
            display: flex;
            position: fixed;
            top: 25px;
            z-index: 10;
            left: 0;
            width: 100%;
            background: $ypo_blue;
            min-height: 56px;
            padding: 10px 55px 10px 15px;
            margin: 0;

            @include breakpoint(sm) {
                top: 64px;
            }
        }
    }

    .header__row__actions {
        @media (min-width: 1024px) {
            flex: 0 1 auto !important;
        }
    }

    .header {
        &__search {
            @include breakpoint(xs) {
                background: $ypo-blue !important;
                padding: 10px 0 10px 0;
            }

            @media (max-width: $screen-xs) {
                position: absolute;
                top: 3px;
                right: 0;
                left: 5px;
                width: 100%;
                margin: 0;
            }

            .v-text-field__details {
                display: none;
            }

            .v-text-field input {
                padding: 0 !important;
            }

            .v-input {
                background-color: $white !important;
                max-height: 30px;
                border-radius: 8px;

                &__slot {
                    margin: 0;
                    padding: 0 !important;
                    border: 1px solid transparent !important;
                    min-height: inherit !important;
                }

                .v-label {
                    color: rgba($black, 0.5) !important;
                    font-size: 14px;
                    top: 2px;
                    font-style: italic;
                }

                .v-icon {
                    height: 14.15px !important;
                    width: 14.15px !important;
                    color: rgba($black, 0.5) !important;
                }

                input {
                    color: $black !important;
                    margin-top: -3px;
                }

                .v-input__append-inner {
                    margin-top: 0;
                    margin-right: -9px;
                }

                .v-input__prepend-outer {
                    margin-top: 3px;
                    margin-left: 5px;
                }

                &--is-focused {
                    background: $white !important;

                    .v-icon {
                        color: $ypo-cta !important;
                    }

                    .v-label {
                        display: none;
                    }
                }
    }

    .search-bar--error {
        input {
            color: $ypo-red !important;
            margin-top: -5px;
        }

        .v-icon {
            color: rgba($ypo-red, 1) !important;
        }

        .v-input__icon--clear {
            .v-icon {
                color: $ypo-cta !important;
            }
        }
      }
    }
  }
}
</style>
